import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Vanaf welk leerjaar kun je met studie connect starten?",
    a: "studie connect kan vanaf het begin van de schoolloopbaan worden ingezet en groeit mee tot de vervolgstap. De school richt de leerlijn in op het eigen onderwijsniveau en programma.",
  },
  {
    q: "Vervangt studie connect de mentor of decaan?",
    a: "Nee. studie connect maakt de mentor en decaan juist sterker. Het platform levert inzicht en overzicht, zodat de begeleider betere gesprekken voert en minder tijd kwijt is aan administratie.",
  },
  {
    q: "Welke rol speelt technologie in het advies?",
    a: "Technologie helpt informatie uit opdrachten, reflecties en andere activiteiten samen te vatten en richtingen te verkennen. De uitkomst is een startpunt voor onderzoek en gesprek, geen beslissing voor de leerling.",
  },
  {
    q: "Hoe zit het met privacy en de AVG?",
    a: "studie connect verwerkt leerlinggegevens in opdracht van de school, met passende technische en organisatorische maatregelen. Persoonsgegevens worden niet verkocht en menselijke beoordeling blijft onderdeel van belangrijke keuzes.",
  },
  {
    q: "Hoeveel werk is het om studie connect in te voeren?",
    a: "We stemmen de inrichting af op het bestaande LOB-programma, nemen het team mee en kunnen klein starten. Zo bepaalt de school zelf een passende invoering en opbouw.",
  },
];

const FaqSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 lg:py-28 animate-on-scroll">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-4 px-3 py-1 bg-accent rounded-full">
            <HelpCircle className="w-3.5 h-3.5" />
            Veelgestelde vragen
          </span>
          <h2 className="text-3xl lg:text-[2.6rem] font-extrabold text-secondary leading-tight">
            Alles wat je wilt weten.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-border bg-card px-5 shadow-soft data-[state=open]:shadow-medium"
            >
              <AccordionTrigger className="text-left text-base font-bold text-secondary hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-10">
          <p className="text-muted-foreground mb-4">Staat je vraag er niet bij?</p>
          <Button
            variant="outline"
            className="rounded-full font-semibold gap-2"
            onClick={() => navigate("/contact")}
          >
            Stel je vraag <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
